
export function userRole(state) {

  if (!state.sessionUser)
    return null;

  return state.sessionUser.roleName;
}
